$(document).ready(function() {
  document.querySelectorAll('.payment-item, .address-item').forEach(parent => {
    if (parent.querySelector('input[type=radio]') == null) return
    parent.querySelector('input[type=radio]').addEventListener('change', el => {
      parent
        .closest('.payment-list, .address-list')
        .querySelectorAll('.payment-item, .address-item')
        .forEach(el => {
          el.classList.remove('active')
        })
      if (el.currentTarget.checked) {
        parent.classList.add('active')
      } else {
        parent.classList.remove('active')
      }
    })
  })
})

// Checkout
$(document).ready(function() {
  document.querySelectorAll('.delivery-item').forEach(parent => {
    parent.querySelector('input[type=radio]').addEventListener('change', el => {
      parent
        .closest('.delivery-list')
        .querySelectorAll('.delivery-item')
        .forEach(el => {
          el.classList.remove('active')
        })
      if (el.currentTarget.checked) {
        parent.classList.add('active')
      } else {
        parent.classList.remove('active')
      }

      const selfPickupTrigger = document.querySelector('.self-pickup-input')

      if (el?.target?.value == 'self-pickup') {
        selfPickupTrigger.classList.remove('d-none')
      } else {
        selfPickupTrigger.classList.add('d-none')
      }
    })
  })
})

// pending checkout

$(document).ready(function() {
  // pending-checkout-item
  const sliderCheckout = document.querySelector('#slider-checkout')
  const totalCheckout = Array.from(document.querySelectorAll('.pending-checkout-item')).length

  if (sliderCheckout) {
    new Swiper(sliderCheckout, {
      direction: 'horizontal',
      speed: 500,
      slidesPerView: totalCheckout > 1 ? 1.1 : 1,
      loop: true,
      spaceBetween: 10,
      autoplay: false,
      pagination: false,
    })
  }
})

$(document).ready(function() {
  document.querySelectorAll('.button-add-to-cart-checkout').forEach(parent => {
    parent.addEventListener('click', function() {
      var url  = parent.dataset.url
      var form = document.querySelector('#add-to-cart-checkout-form')

      if (form != null) {
        form.action = url
        form.submit()
      }
    })
  })
})
